import { render, staticRenderFns } from "./CompanyProcedures.vue?vue&type=template&id=04c2dbce"
import script from "./CompanyProcedures.vue?vue&type=script&lang=js"
export * from "./CompanyProcedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports